export const changeTripType = (tripType) => ({
  type: 'CHANGE_TRIP_TYPE',
  tripType,
})

export const changeTravelers = (travelers) => ({
  type: 'CHANGE_TRAVELER_SELECTION',
  travelers,
})

export const changeCabinClass = (cabinClass) => ({
  type: 'CHANGE_CABIN_CLASS',
  cabinClass,
})

export const changeCalendarPriceMap = (calendarPricingMap) => ({
  type: 'CHANGE_CALENDAR_PRICING_MAP',
  calendarPricingMap,
})

export const toggleFlexDates = (flexDates) => ({
  type: 'TOGGLE_FLEX_DATES',
  flexDates,
})

export const changePreferredAirline = (preferredAirline) => ({
  type: 'CHANGE_PREFERRED_AIRLINE',
  preferredAirline,
})

export const removeSlice = (index) => ({
  type: 'REMOVE_SLICE',
  index,
})

export const addSlice = ({ origAirportCode, destAirportCode, date, origIsGDSCity, destIsGDSCity } = {}) => ({
  type: 'ADD_SLICE',
  origAirportCode,
  destAirportCode,
  origIsGDSCity,
  destIsGDSCity,
  date,
})

export const updateSlice = (index, slice) => ({
  type: 'UPDATE_SLICE',
  index,
  slice,
})

export const addAirport = (airport) => ({
  type: 'ADD_AIRPORT',
  airport,
})

export const updateSlicesForTripType = (tripType, rtReturnSlice) => ({
  type: 'UPDATE_SLICES_FOR_TRIP_TYPE',
  tripType,
  rtReturnSlice,
})

export const setDirtyFlag = () => ({
  type: 'SET_DIRTY_FLAG',
})

export const didSubmitForm = (resetFlag = false) => ({
  type: 'DID_SUBMIT_FORM',
  resetFlag,
})

export const setRtReturnSlice = (rtReturnSlice) => ({
  type: 'SET_RT_RETURN_SLICE',
  rtReturnSlice,
})

export const setPrefAirlineDirty = (isPrefAirlineDirty = true) => ({
  type: 'SET_PREF_AIRLINE_DIRTY',
  isPrefAirlineDirty,
})

export const setTravelersDirty = (isTravelersDirty = true) => ({
  type: 'SET_TRAVELERS_DIRTY',
  isTravelersDirty,
})

export const setAirlines = (airlines) => ({
  type: 'SET_AIRLINES',
  airlines,
})

export const setFocusedInput = (input, name) => ({
  type: 'SET_FOCUSED_INPUT',
  input,
  name,
})

export const setStacked = (stacked) => ({
  type: 'SET_STACKED',
  stacked,
})

export const resetForm = () => ({
  type: 'RESET_FORM',
})
